module.exports = __webpack_public_path__ + "assets/img/3020.50290c45.png";